<div
  class="modal fade"
  id="sharedViewModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="sharedViewModal"
  aria-hidden="true"
  data-backdrop="static"
  data-keyboard="false"
>
  <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header col-12">
        <h4 class="modal-title" id="sharedViewModalLabel">
          {{ this.heading }}
        </h4>
        <button type="button" class="close">
          <img
            src="./assets/icons/close.svg"
            (click)="closeModal()"
            alt="Close"
          />
        </button>
      </div>
      <div
        class="modal-body position-relative text-center px-0 pb-2"
        id="viewModalBody"
      >
        <ngx-doc-viewer
          *ngIf="
            this.fileViewer != 'url' &&
            this.fileViewer != 'google' &&
            this.fileViewer != 'image'
          "
          id="docViewer"
          class="doc-viewer-style"
          [url]="fileUrl"
          [viewer]="fileViewer"
        ></ngx-doc-viewer>
        <iframe
          *ngIf="
            this.fileViewer === 'url' ||
            (this.fileViewer === 'google' && this.fileUrl != null)
          "
          id="myIframe"
          class="doc-viewer-style"
          [src]="fileUrl"
        ></iframe>
        <p-image
          *ngIf="this.fileViewer === 'image'"
          [src]="fileUrl"
          alt="Image"
          width="250"
          [preview]="true"

        />
      </div>
    </div>
  </div>
</div>